export const PEER_REVIEW_DEFAULT_RANGE_DAYS = 7;

export function localIsoDate(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function todayIsoDate(reference: Date = new Date()): string {
  return localIsoDate(reference);
}

/** Last N calendar days inclusive of today (7 days => today minus 6). */
export function defaultFromDate(
  daysInclusive = PEER_REVIEW_DEFAULT_RANGE_DAYS,
  reference: Date = new Date()
): string {
  const d = new Date(reference);
  d.setDate(d.getDate() - (daysInclusive - 1));
  return localIsoDate(d);
}

export function inclusiveDayCount(fromDate: string, toDate: string): number {
  const start = new Date(`${fromDate}T00:00:00`);
  const end = new Date(`${toDate}T00:00:00`);
  const diffMs = end.getTime() - start.getTime();
  if (!Number.isFinite(diffMs) || diffMs < 0) {
    return 0;
  }
  return Math.floor(diffMs / (24 * 60 * 60 * 1000)) + 1;
}
